import { useMutation } from '@tanstack/react-query';
import type { RespondedType, ResponseError } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export default function useVerifyPassword() {
  return useMutation<RespondedType, ResponseError, string>({
    mutationKey: ['/CheckPassword'],
    mutationFn: (params) =>
      fetcher(
        '/CheckPassword',
        { Password: params },
        {
          validResponseCodes: [0],
        },
      ),
  });
}
